{
  "F101": {
    "coordinator": {
      "title": "De eerste vraag moet beantwoord worden",
      "actions": "<ul><li>Herstel de fout door op papier de juiste optie(s) aan te (laten) vinken.</li></ul>"
    }
  },
  "F102": {
    "coordinator": {
      "title": "De tweede vraag moet beantwoord worden",
      "content": "Als er extra onderzoek is gedaan, moeten beide vragen beantwoord worden."
    }
  },
  "F103": {
    "coordinator": {
      "title": "De tweede vraag moet overgeslagen worden",
      "content": "Als er geen extra onderzoek is gedaan, mag alleen de eerste vraag beantwoord worden."
    }
  },
  "F104": {
    "coordinator": {
      "title": "Er mag maar één antwoord per vraag worden gegeven"
    }
  },
  "F111": {
    "coordinator": {
      "title": "Bij beide vragen moet een antwoord gegeven worden"
    }
  },
  "F112": {
    "coordinator": {
      "title": "Er mag maar één antwoord per vraag worden gegeven"
    }
  },
  "F121": {
    "typist": {
      "actions": "<ul><li>Beantwoord de vragen over het papieren proces-verbaal.</li><li>Overleg met de coördinator als je twijfelt.</li></ul>"
    },
    "coordinator": {
      "title": "Er is niet correct aangegeven welke documenten zijn ingevoerd",
      "actions": "<ul><li>Bekijk welke documenten aanwezig zijn.</li><li>Geef daarna de invoer terug aan de invoerder zodat deze vraag opnieuw beantwoord kan worden.</li></ul>"
    }
  },
  "F122": {
    "typist": {
      "title": "Het inlegvel ontbreekt, maar hoort wel aanwezig te zijn",
      "actions": "<ul><li>Overleg met de coördinator over het ontbrekende inlegvel.</li></ul>"
    },
    "coordinator": {
      "title": "Het inlegvel ontbreekt, maar hoort wel aanwezig te zijn",
      "actions": "<ul><li>Zorg dat een correct ingevuld inlegvel wordt toegevoegd.</li><li>Geef daarna de invoer terug aan de invoerder zodat deze vraag opnieuw beantwoord kan worden.</li></ul>"
    }
  },
  "F131": {
    "coordinator": {
      "title": "De vragen op het inlegvel zijn niet volledig beantwoord",
      "actions": "<ul><li>Zorg dat het inlegvel volledig is ingevuld.</li><li>Geef daarna de invoer terug aan de invoerder zodat deze vraag opnieuw beantwoord kan worden.</li></ul>"
    }
  },
  "F132": {
    "typist": {
      "content": "Er is een corrigendum, maar er zijn volgens de antwoorden op het inlegvel 'controles en correcties' geen gecorrigeerde telresultaten.",
      "actions": "<ul><li>Overleg met de coördinator.</li></ul>"
    },
    "coordinator": {
      "title": "Onterecht corrigendum?",
      "content": "Er is een corrigendum, maar er zijn volgens de antwoorden op het inlegvel 'controles en correcties' geen gecorrigeerde telresultaten.",
      "actions": "<ul><li>Als er geen gecorrigeerde telresultaten zijn, dan hoort er ook geen corrigendum te zijn.</li><li>Verwijder het corrigendum, of geef op het inlegvel aan dat er wel gecorrigeerde telresultaten zijn.</li><li>Geef daarna de invoer terug aan de invoerder.</li></ul>"
    }
  },
  "F133": {
    "typist": {
      "content": "Er is geen corrigendum, maar er zijn volgens de antwoorden op het inlegvel 'controles en correcties' wel gecorrigeerde telresultaten.",
      "actions": "<ul><li>Overleg met de coördinator.</li></ul>"
    },
    "coordinator": {
      "title": "Ontbrekend corrigendum?",
      "content": "Er is geen corrigendum, maar er zijn volgens de antwoorden op het inlegvel 'controles en correcties' wel gecorrigeerde telresultaten.",
      "actions": "<ul><li>Als er gecorrigeerde telresultaten zijn, dan hoort er ook een corrigendum te zijn.</li><li>Voeg het correcte corrigendum toe, of geef op het inlegvel aan dat er geen gecorrigeerde telresultaten zijn.</li><li>Geef daarna de invoer terug aan de invoerder.</li></ul>"
    }
  },
  "F134": {
    "coordinator": {
      "title": "Er mag maar 1 antwoord per vraag worden gegeven",
      "actions": "<ul><li>Herstel de fout door op papier de juiste optie(s) aan te (laten) vinken.</li></ul>"
    }
  },
  "F135": {
    "coordinator": {
      "title": "Tijdens de eerste zitting kan er nog geen verzoek van het Centraal Stembureau zijn",
      "actions": "<ul><li>Herstel de fout door op papier de juiste optie(s) aan te (laten) vinken.</li></ul>"
    }
  },
  "F201": {
    "coordinator": {
      "title": "A, B en C tellen niet op tot D",
      "content": "Controleer in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting) of er een onverklaard verschil opgelost wordt als het juiste getal bij D wordt ingevuld.",
      "actions": "<ul><li>Zo ja: herstel op papier de optelfout door bij D het juiste getal in te vullen.</li><li>Zo nee: tel de stembiljetten en het aantal toegelaten kiezers opnieuw tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F202": {
    "coordinator": {
      "title": "De stemmen op lijsten tellen niet op tot E",
      "content": "Controleer in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting) of er een onverklaard verschil opgelost wordt als de juiste getallen bij E en H worden ingevuld.",
      "actions": "<ul><li>Zo ja: herstel op papier de optelfout door bij E en H de juiste getallen in te vullen.</li><li>Zo nee: tel de stembiljetten en het aantal toegelaten kiezers opnieuw tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F203": {
    "coordinator": {
      "title": "E, F en G tellen niet op tot H",
      "content": "Controleer in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting) of er een onverklaard verschil opgelost wordt als het juiste getal bij H wordt ingevuld.",
      "actions": "<ul><li>Zo ja: herstel op papier de optelfout door bij H het juiste getal in te vullen.</li><li>Zo nee: tel de stembiljetten en het aantal toegelaten kiezers opnieuw tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F204": {
    "coordinator": {
      "title": "Het totaal aantal stemmen op kandidaten is niet ingevuld",
      "content": "Controleer in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting) of er een onverklaard verschil opgelost wordt als de juiste getallen bij E en E.1 t/m E.n worden ingevuld.",
      "actions": "<ul><li>Zo ja: herstel op papier de optelfout door bij E en E.1 t/m E.n de juiste getallen in te vullen.</li><li>Zo nee: tel de stembiljetten en het aantal toegelaten kiezers opnieuw tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F301": {
    "coordinator": {
      "title": "De getallen die zijn ingevuld bij D en H zijn niet gelijk",
      "actions": "<ul><li>Herstel de fout door op papier het juiste getal in te (laten) vullen.</li><li>Controleer ook of er een onverklaard verschil ontstaat.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "F302": {
    "coordinator": {
      "title": "Het getal dat is ingevuld bij H is niet groter dan D"
    }
  },
  "F303": {
    "coordinator": {
      "title": "Het getal dat is ingevuld bij H is niet kleiner dan D"
    }
  },
  "F304": {
    "coordinator": {
      "title": "Deze vraag moet precies één antwoord hebben"
    }
  },
  "F305": {
    "coordinator": {
      "title": "Controleer I en J",
      "content": "De getallen bij D en H zijn gelijk. Er zijn geen stemmen meer of minder geteld.",
      "actions": "<ul><li>Herstel de fout door op papier I en/of J leeg te (laten) maken.</li></ul>"
    }
  },
  "F306": {
    "coordinator": {
      "title": "Controleer aantal méér getelde stemmen (I)",
      "actions": "<ul><li>Herstel de fout door op papier het juiste getal in te (laten) vullen.</li><li>Controleer ook of het verschil nog volledig verklaard is.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "F307": {
    "coordinator": {
      "title": "Controleer of I en J verwisseld zijn",
      "actions": "<ul><li>Herstel de fout door op papier het verschil op de juiste plek in te (laten) vullen.</li><li>Controleer ook of het verschil nog volledig verklaard is.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "F308": {
    "coordinator": {
      "title": "Controleer aantal minder getelde stemmen (J)",
      "actions": "<ul><li>Herstel de fout door op papier het juiste getal in te (laten) vullen.</li><li>Controleer ook of het verschil nog volledig verklaard is.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "F309": {
    "coordinator": {
      "title": "Controleer of I en J verwisseld zijn",
      "actions": "<ul><li>Herstel de fout door op papier het verschil op de juiste plek in te (laten) vullen.</li><li>Controleer ook of het verschil nog volledig verklaard is.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "F310": {
    "coordinator": {
      "title": "Deze vraag moet precies één antwoord hebben",
      "content": "Bij vraag 3.2.3 (eerste zitting) of 2.3.2 (volgende zitting) moet één antwoord gekozen worden."
    }
  },
  "F311": {
    "coordinator": {
      "title": "Hertel onverklaard verschil",
      "content": "Er is een onverklaard verschil dat herteld moet worden.",
      "actions": "<ul><li>Hertel de stembiljetten en het aantal toegelaten kiezers. Hertel tot de fout gevonden is, of alles één keer herteld is.</li><li>Vul nieuwe telresultaten op een corrigendum in.</li><li>Is er al herteld? Zorg dan dat het inlegvel 'controles en correcties' wordt ingevuld en toegevoegd aan het proces-verbaal van het stembureau.</li></ul>"
    }
  },
  "F313": {
    "coordinator": {
      "title": "Deze vraag moet overgelagen worden",
      "content": "D en H zijn gelijk, dus er is geen onverklaard verschil. Vraag 3.2.3 (eerste zitting) of 2.3.2 (volgende zitting) moet overgeslagen worden."
    }
  },
  "F401": {
    "typist": {
      "title": "Controleer het totaal van de lijst. Is dit veld op het papieren proces-verbaal ook leeg? Dan kan je verdergaan. (F.401)"
    },
    "coordinator": {
      "title": "Het totaal van de lijst is niet ingevuld",
      "content": "Controleer of het proces-verbaal tijdens het telproces volledig is ingevuld (controleer ook E.{political_group_number} in rubriek 3.2 (eerste zitting) of 2.2 (volgende zitting)).\nKijk of het corrigeren van de fout een onverklaard verschil wegneemt in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting).",
      "actions": "<ul><li>Zo ja: corrigeer de optelfout op het papieren proces-verbaal.</li><li>Zo nee: onderzoek wat er fout is gegaan en tel zo nodig de stembiljetten en het aantal toegelaten kiezers opnieuw. Begin bij deze lijst, en hertel tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F402": {
    "typist": {
      "title": "Controleer ingevoerde aantallen",
      "content": "De opgetelde stemmen op de kandidaten en het ingevoerde totaal zijn niet gelijk."
    },
    "coordinator": {
      "title": "De stemmen op kandidaten tellen niet op tot het lijsttotaal",
      "content": "Controleer of het proces-verbaal tijdens het telproces volledig is ingevuld.\nReken de optelling in het papieren proces-verbaal na.\nKijk of het corrigeren van de fout een onverklaard verschil wegneemt in rubriek 3.3 (eerste zitting) of 2.3 (volgende zitting).",
      "actions": "<ul><li>Zo ja: corrigeer de optelfout op het papieren proces-verbaal.</li><li>Zo nee: onderzoek wat er fout is gegaan en tel zo nodig de stembiljetten en het aantal toegelaten kiezers opnieuw. Begin bij deze lijst, en hertel tot de fout gevonden is, of alles één keer herteld is.</li></ul>"
    }
  },
  "F403": {
    "typist": {
      "title": "Controleer het totaal van de lijst",
      "content": "Als het totaal overeenkomt met het papieren proces-verbaal, controleer dan ook de waarde bij E.{political_group_number} bij <Link to=\"../voters_votes_counts\">Aantal kiezers en stemmen</Link>."
    },
    "coordinator": {
      "title": "Controleer het totaal van de lijst en E.{political_group_number} in rubriek 3.2 (eerste zitting) of 2.2 (volgende zitting)",
      "actions": "<ul><li>Controleer wat er fout is gegaan in rubriek 3.2 (eerste zitting) of 2.2 (volgende zitting) en herstel de fout.</li><li>Pas zo nodig rubriek 3.3.2 (eerste zitting) of 2.3.2 (volgende zitting) aan, en volg de instructies over hertellen die daar staan.</li></ul>"
    }
  },
  "W001": {
    "typist": {
      "title": "Extra controle nodig",
      "content": "De gemarkeerde velden zijn anders dan in de eerste invoer."
    },
    "coordinator": {
      "title": "W.001 is er alleen voor invoerders",
      "content": "Voor de coördinator hebben we het scherm 'verschillen oplossen'."
    }
  },
  "W002": {
    "typist": {
      "title": "Verschil met andere invoer. Nieuwe invoer nodig",
      "content": "Een coördinator heeft beide invoeren vergeleken, en aangegeven dat in deze invoer fouten zijn gemaakt. Neem de gemarkeerde velden opnieuw over van het papieren proces verbaal.",
      "actions": "<ul><li>Heb je alles ingevuld en komt je invoer overeen met het papier? Ga dan verder.</li></ul>"
    },
    "coordinator": {
      "title": "W.002 is er alleen voor invoerders",
      "content": "Voor de coördinator hebben we het scherm 'verschillen oplossen'."
    }
  },
  "W201": {
    "coordinator": {
      "title": "Het aantal blanco stemmen (F) is erg hoog",
      "actions": "<ul><li>Hertel de blanco stemmen of geef een verklaring voor het hoge aantal.</li><li>Geef in elk geval aan wat je hebt gedaan in het proces-verbaal van het GSB (rubriek 1.2).</li></ul>"
    }
  },
  "W202": {
    "coordinator": {
      "title": "Het aantal ongeldige stemmen (G) is erg hoog",
      "actions": "<ul><li>Hertel de ongeldige stemmen of geef een verklaring voor het hoge aantal.</li><li>Geef in elk geval aan wat je hebt gedaan in het proces-verbaal van het GSB (rubriek 1.2).</li></ul>"
    }
  },
  "W203": {
    "coordinator": {
      "title": "Groot verschil tussen D en H",
      "content": "Er is een groot verschil tussen het aantal toegelaten kiezers (D) en het aantal uitgebrachte stemmen (H).",
      "actions": "<ul><li>Tel het stembureau in zijn geheel nogmaals. Dit hoeft niet als er al twee keer geteld is met precies dezelfde uitkomst per lijst.</li><li>Verklaar in het proces-verbaal van het GSB (rubriek 1.2) zo goed mogelijk wat de oorzaak van de opmerkelijke uitkomst is.</li><li>Schrijf ook op welke stappen het GSB heeft gezet om deze te hertellen en onderzoeken.</li></ul>"
    }
  },
  "W204": {
    "coordinator": {
      "title": "Het totaal aantal uitgebrachte stemmen (H) is nul",
      "content": "Controleer of het stembureau is opgenomen in de vóór de verkiezing gepubliceerde lijst.",
      "actions": "<ul><li>Zo ja: verklaar in het proces-verbaal van het GSB (rubriek 1.2) waarom in dit stembureau geen stemmen zijn uitgebracht.</li><li>Zo nee: verwijder het stembureau uit Abacus. Het proces-verbaal moet niet ingevoerd worden.</li></ul>"
    }
  }
}
